import { CardHeader, styled } from "@woba/ds-web";

export const CardHeaderStyle = styled(CardHeader, {
  marginBottom: "$space-05",
});

export const CardHeaderTitle = styled("div", {
  display: "flex",
  alignItems: "center",

  svg: {
    width: 14,
    height: 14,
    color: "$neutral-700",
  },

  h3: {
    fontSize: "$md",
    fontWeight: "500",
    marginRight: "$space-03",
  },

  span: {
    display: "flex",
  },
});

export const ExtraLabel = styled("span", {
  fontSize: "$sm",
  color: "$neutral-700",
  marginRight: "$space-03",
});
